import {CredentialsSchema} from "@client/contracts";
import {zodResolver} from "@hookform/resolvers/zod";
import {type FC, useState} from "react";
import {useForm} from "react-hook-form";
import type z from "zod";
import {rpc} from "../store/rpcs.mjs";
import {SessionAtom} from "../store/session.mjs";

const Authorize: FC = () => {
    const form = useForm<z.input<typeof CredentialsSchema>>({resolver: zodResolver(CredentialsSchema)});
    const [reason, setReason] = useState<string | null>(null);
    const {errors, isSubmitting} = form.formState;

    const onSubmit = form.handleSubmit(async (values) => {
        setReason(null);

        try {
            const {auth} = await rpc.query({auth: {signIn: [values]}});
            SessionAtom.set(auth.signIn);
        } catch (error) {
            setReason(error instanceof Error ? error.message : "Не удалось войти");
        }
    });

    return (
        <dialog open>
            <article className="box">
                <h1>{"Egressor"}</h1>
                <p>{"Вход в кабинет"}</p>

                <form onSubmit={onSubmit}>
                    <fieldset>
                        <label>
                            {"Email"}
                            <input
                                {...form.register("email")}
                                placeholder="you@example.com"
                                autoComplete="username"
                                aria-invalid={errors.email && "true"}
                            />
                            {errors.email && <small>{errors.email.message}</small>}
                        </label>
                        <label>
                            {"Пароль"}
                            <input
                                {...form.register("password")}
                                type="password"
                                autoComplete="current-password"
                                aria-invalid={errors.password && "true"}
                            />
                            {errors.password && <small>{errors.password.message}</small>}
                        </label>
                    </fieldset>

                    {reason && <small className="error">{reason}</small>}

                    <button disabled={isSubmitting} type="submit">
                        {"Войти"}
                    </button>
                </form>
            </article>
        </dialog>
    );
};

export default Authorize;
